import { useCallback, useContext, useEffect, useRef, useState } from "react";

import Select from "react-select";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { AppSettings } from "../../config/app-settings";
import FileItem from "./FileItem";
import apiClient from "../../ApiClient";
import ImportFile from "../../components/import-file";
import toastMessage from "../../components/ToastMessage";
import moment from "moment";

export default function YuklenenDosyalar() {
  const context = useContext(AppSettings);

  const [connectionType, setConnectionType] = useState("local");

  const [selectedOperatorOptions, setSelectedOperatorOptions] = useState([
    { value: "and", label: "Ve" },
    { value: "or", label: "Veya" },
  ]);

  const [selectedConditionOptions, setSelectedConditionOptions] = useState([
    { value: "=", label: "=" },
    { value: "!=", label: "!=" },
    { value: ">", label: ">" },
    { value: ">=", label: ">=" },
    { value: "<", label: "<" },
    { value: "<=", label: "<=" },
    { value: "in", label: "İÇİNDE" },
    { value: "notin", label: "DIŞINDA" },
    { value: "like", label: "BENZER" },
    { value: "notlike", label: "BENZEMEZ" },
    { value: "isnull", label: "BOŞ" },
    { value: "isnotnull", label: "DOLU" },
  ]);

  useEffect(() => {
    if (context && context.t) {
      setSelectedOperatorOptions([
        { value: "and", label: context?.t?.and },
        { value: "or", label: context?.t?.or },
      ]);

      setSelectedConditionOptions([
        { value: "=", label: "=" },
        { value: "!=", label: "!=" },
        { value: ">", label: ">" },
        { value: ">=", label: ">=" },
        { value: "<", label: "<" },
        { value: "<=", label: "<=" },
        { value: "in", label: context?.t?.in },
        { value: "notin", label: context?.t?.out },
        { value: "like", label: context?.t?.like },
        { value: "notlike", label: context?.t?.notLike },
        { value: "isnull", label: context?.t?.empty },
        { value: "isnotnull", label: context?.t?.filled },
      ]);
    }
  }, [context]);

  const [fileTypesCustomer, setFileTypesCustomer] = useState(null);
  const [fileTypes, setFileTypes] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);

  const [typeData, setTypeData] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  const [showRemoveButton, setShowRemoveButton] = useState(false);

  const handleFileTypesCustomer = useCallback(async (e, connection) => {
    setFileTypes(null);
    setSearchTerm("");

    try {
      const response = await apiClient.get(
        `/types?connection_type=${connection}${
          e.value ? `&customer=${e.value}` : ""
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response) {
        setFileTypes(response.data);
      } else {
        setFileTypes(null);
      }
    } catch (error) {
      console.error("Get File Types Error", error);
    }

    setFileTypesCustomer(e);
  }, []);

  useEffect(() => {
    if (context?.me?.customer?.id) {
      const customerControl = context?.me?.role?.id === 1 && {
        value: context.me.customer.id,
        label: context.me.customer.customer.name,
        user_id: context.me.id,
      };

      handleFileTypesCustomer(customerControl, connectionType);
    }
    // 'context?.me?.customer?.id' sadece bu değiştiğinde çalışacak
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context?.me?.customer?.id, connectionType]);

  //--

  const [conditions, setConditions] = useState([
    { column: "", operator: "", value: "", condition: "" },
  ]);

  const [previewData, setPreviewData] = useState({ data: [] });
  const [fetchDataArray, setFetchDataArray] = useState(null);

  const handleAddCondition = () => {
    setConditions([
      ...conditions,
      { column: "", operator: "", value: "", condition: "" },
    ]);
  };

  const handleRemoveCondition = (index) => {
    setConditions(conditions.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const updatedConditions = conditions.map((condition, i) => {
      if (i === index) {
        if (
          field === "operator" &&
          (value.value === "isnull" || value.value === "isnotnull")
        ) {
          return { ...condition, [field]: value, value: "" };
        }
        return { ...condition, [field]: value };
      }
      return condition;
    });
    setConditions(updatedConditions);
  };

  const handleSubmit = async () => {
    setPreviewData(null);

    if (
      conditions.length === 0 ||
      conditions.some(
        (cond) =>
          !cond.column ||
          !cond.operator ||
          (cond.operator.value !== "isnull" &&
            cond.operator.value !== "isnotnull" &&
            !cond.value) ||
          !cond.condition
      )
    ) {
      toastMessage(context?.t?.doldur_ve_en_az_bir_kosul_ekleyin, "error");
      return;
    }

    const data = {
      chart: 1,
      page_id: 51,
      title: "-",
      description: "",
      status: true,
      order: 1,
      paginate: true,
      type: typeData.type.type,
      customer: fileTypesCustomer.value,
      connection_type: connectionType,
      sql: {
        column: typeData.column.map((item) => ({
          key: item.replace(/[/\\']/g, ""),
          value: "select",
        })),
        condition:
          conditions.length !== 0
            ? conditions.map((item) => {
                return {
                  key: item.column.value,
                  value: item.value,
                  operator: item.operator.value,
                  type: item.condition.value,
                };
              })
            : [],
        group: [],
      },
    };

    setFetchDataArray(data);
    fetchData(1, data);
  };

  useEffect(() => {
    setConditions([{ column: "", operator: "", value: "", condition: "" }]);
    setPreviewData({ data: [] });
    setFetchDataArray(null);
    setShowRemoveButton(false);
  }, [typeData]);

  const fetchData = async (page, data) => {
    try {
      const response = await apiClient.customPost(
        `/query/preview?page=${page}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setPreviewData(response);
    } catch (error) {
      setPreviewData(null);
      console.error(error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, fetchDataArray);
  };

  //--

  const [deleteLoader, setDeleteLoader] = useState(false);

  async function handleFileDelete(file, condition) {
    if (!file) {
      toastMessage(context?.t?.dosya_bulunamadi, "error");
      return;
    }

    const payload = {
      connection_type: connectionType,
      sql: {
        condition: condition
          ? conditions.map((item) => ({
              key: item.column.value,
              value: item.value,
              operator: item.operator.value,
              type: item.condition.value,
            }))
          : [],
      },
      type: file,
    };

    setDeleteLoader(true);

    try {
      const response = await apiClient.customPost(`/delete/query`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setDeleteLoader(false);

      if (response.success) {
        toastMessage(context?.t?.veriler_silindi, "success");
        setTimeout(() => {
          document.getElementById("yuklenenDosyalarModalCloseButton").click();
          document
            .getElementById("yuklenenDosyalarDeleteModalCloseButton")
            .click();
          handleFileTypesCustomer(
            context?.me?.role?.id === 1
              ? {
                  value: fileTypesCustomer.value,
                  label: fileTypesCustomer.label,
                }
              : {
                  value:
                    localStorage.getItem("user") &&
                    JSON.parse(localStorage.getItem("user")).customer.id,
                  label:
                    localStorage.getItem("user") &&
                    JSON.parse(localStorage.getItem("user")).customer.customer
                      .name,
                },
            connectionType
          );
        }, 300);
      }
    } catch (error) {
      setDeleteLoader(false);
      console.error(error);
    }
  }

  // Satır Ekle/Güncelle
  const [fileItemEvents, setFileItemEvents] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (fileItemEvents) {
      const updatedFormData = {};

      const columns = fileItemEvents.column?.columns || [];
      const values = fileItemEvents.row
        ? Object.values(fileItemEvents.row)
        : [];

      // Eğer row varsa title'larla value'ları eşleştir
      if (values.length > 0) {
        columns.forEach((title, index) => {
          updatedFormData[title] = values[index] ?? "";
        });
      } else {
        // Row boşsa tüm title'ları boş string olarak ata
        columns.forEach((title) => {
          updatedFormData[title] = "";
        });
      }

      setFormData(updatedFormData);
    } else {
      setFormData({});
    }
  }, [fileItemEvents]);

  const handleInputChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const formatDatesInJson = (obj) => {
    if (obj && typeof obj === "object") {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (
            typeof value === "object" &&
            value !== null &&
            moment(value).isValid()
          ) {
            obj[key] = moment(value).format("YYYY-MM-DD");
          }
        }
      }
    }
    return obj;
  };

  const printRef = useRef();

  function handlePrint() {
    const printContent = printRef.current;

    if (printContent) {
      const printWindow = window.open("", "_blank");
      if (printContent && printWindow) {
        printWindow.document.write(
          `
        <html>
          <head>
            <title>` +
            (window.location.host.includes("datakokpit")
              ? "Datakokpit"
              : "Strateji Merkezi") +
            `</title>
            <style>
            .row { --bs-gutter-x: 20px; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1* var(--bs-gutter-y)); margin-right: calc(-0.5* var(--bs-gutter-x)); margin-left: calc(-0.5* var(--bs-gutter-x)); } .g-4, .gy-4 { --bs-gutter-y: 1.5rem; } .g-4, .gx-4 { --bs-gutter-x: 1.5rem; } .col { flex: 1 0; } .row > * { flex-shrink: 0; width: 100%; max-width: 100%; padding-right: calc(var(--bs-gutter-x)* 0.5); padding-left: calc(var(--bs-gutter-x)* 0.5); margin-top: var(--bs-gutter-y); } label { display: block; } .form-control { display: block; width: 100%; padding: 0.375rem 0.75rem; font-size: 0.875rem; font-weight: 400; line-height: 1.5; color: var(--bs-body-color); appearance: none; background-color: transparent; background-clip: padding-box; border: var(--bs-border-width) solid var(--bs-border-color); border-radius: 4px; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; } .row.g-4 { max-width: 1000px; margin: 0 auto; display: grid; grid-template-columns: repeat(2, 1fr); }
            :root,[data-bs-theme=light] { --bs-white-rgb: 255,255,255; --bs-black-rgb: 0,0,0; --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"; --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace; --bs-gradient: linear-gradient(180deg,#ffffff26,#fff0); --bs-body-font-family: "Chakra Petch",sans-serif; --bs-body-font-size: 0.875rem; --bs-border-width: 1px; --bs-border-style: solid; --bs-border-color: #0003; } *,:after,:before { box-sizing: border-box } @media(prefers-reduced-motion:no-preference) { :root { scroll-behavior: smooth } } body { font-family: var(--bs-body-font-family); } hr { border: 0; border-top: 1px solid; border-top: var(--bs-border-width) solid; color: inherit; margin: 1rem 0; opacity: .25 } .h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6 { color: black; font-weight: 600; line-height: 1.2; margin-bottom: .5rem; margin-top: 0 } .h1,h1 { font-size: calc(1.34375rem + 1.125vw) } @media(min-width: 1200px) { .h1,h1 { font-size:2.1875rem } } .h2,h2 { font-size: calc(1.3rem + .6vw) } @media(min-width: 1200px) { .h2,h2 { font-size:1.75rem } } .h3,h3 { font-size: calc(1.27813rem + .3375vw) } @media(min-width: 1200px) { .h3,h3 { font-size:1.53125rem } } .h4,h4 { font-size: calc(1.25625rem + .075vw) } @media(min-width: 1200px) { .h4,h4 { font-size:1.3125rem } } .h5,h5 { font-size: 1.09375rem } .h6,h6 { font-size: .875rem } p { margin-bottom: 1rem; margin-top: 0 } x .card { --bs-card-spacer-y: 1rem; --bs-card-spacer-x: 1rem; --bs-card-title-spacer-y: 0.5rem; --bs-card-title-color: ; --bs-card-subtitle-color: ; --bs-card-border-width: var(--bs-border-width); --bs-card-border-color: var(--bs-border-color-translucent); --bs-card-border-radius: var(--bs-border-radius); --bs-card-box-shadow: ; --bs-card-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width)); --bs-card-cap-padding-y: 0.5rem; --bs-card-cap-padding-x: 1rem; --bs-card-cap-bg: rgba(var(--bs-body-color-rgb),0.03); --bs-card-cap-color: ; --bs-card-height: ; --bs-card-color: ; --bs-card-bg: #0000; --bs-card-img-overlay-padding: 1rem; --bs-card-group-margin: 10px; word-wrap: break-word; background-clip: initial; background-color: var(--bs-card-bg); border: var(--bs-card-border-width) solid var(--bs-card-border-color); border-radius: var(--bs-card-border-radius); color: #000000bf; color: var(--bs-body-color); display: flex; flex-direction: column; height: var(--bs-card-height); min-width: 0 } .card>hr { margin-left: 0; margin-right: 0 } .card>.list-group { border-bottom: inherit; border-top: inherit } .card>.list-group:first-child { border-top-left-radius: var(--bs-card-inner-border-radius); border-top-right-radius: var(--bs-card-inner-border-radius); border-top-width: 0 } .card>.list-group:last-child { border-bottom-left-radius: var(--bs-card-inner-border-radius); border-bottom-right-radius: var(--bs-card-inner-border-radius); border-bottom-width: 0 } .card>.card-header+.list-group,.card>.list-group+.card-footer { border-top: 0 } .card-body { color: #000000c4; flex: 1 1 auto; padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x) } .card-title { color: var(--bs-card-title-color); margin-bottom: var(--bs-card-title-spacer-y) } .card-subtitle { color: var(--bs-card-subtitle-color); margin-top: calc(var(--bs-card-title-spacer-y)*-.5) } .card-subtitle,.card-text:last-child { margin-bottom: 0 } .card-link+.card-link { margin-left: var(--bs-card-spacer-x) } .card-header { background-color: var(--bs-card-cap-bg); border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color); color: var(--bs-card-cap-color); margin-bottom: 0; padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x) } .card-header:first-child { border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0 } .card-footer { background-color: var(--bs-card-cap-bg); border-top: var(--bs-card-border-width) solid var(--bs-card-border-color); color: var(--bs-card-cap-color); padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x) } .card-footer:last-child { border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) } .card-header-tabs { border-bottom: 0; margin-bottom: calc(var(--bs-card-cap-padding-y)*-1); margin-left: calc(var(--bs-card-cap-padding-x)*-.5); margin-right: calc(var(--bs-card-cap-padding-x)*-.5) } .card-header-tabs .nav-link.active { background-color: var(--bs-card-bg); border-bottom-color: var(--bs-card-bg) } .card-header-pills { margin-left: calc(var(--bs-card-cap-padding-x)*-.5); margin-right: calc(var(--bs-card-cap-padding-x)*-.5) } .card-img-overlay { border-radius: var(--bs-card-inner-border-radius); bottom: 0; left: 0; padding: var(--bs-card-img-overlay-padding); position: absolute; right: 0; top: 0 } .card-img,.card-img-bottom,.card-img-top { width: 100% } .card-img,.card-img-top { border-top-left-radius: var(--bs-card-inner-border-radius); border-top-right-radius: var(--bs-card-inner-border-radius) } .card-img,.card-img-bottom { border-bottom-left-radius: var(--bs-card-inner-border-radius); border-bottom-right-radius: var(--bs-card-inner-border-radius) } .card-group>.card { margin-bottom: var(--bs-card-group-margin) } @media(min-width: 576px) { .card-group { display:flex; flex-flow: row wrap } .card-group>.card { flex: 1 0; margin-bottom: 0 } .card-group>.card+.card { border-left: 0; margin-left: 0 } .card-group>.card:not(:last-child) { border-bottom-right-radius: 0; border-top-right-radius: 0 } .card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top { border-top-right-radius: 0 } .card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom { border-bottom-right-radius: 0 } .card-group>.card:not(:first-child) { border-bottom-left-radius: 0; border-top-left-radius: 0 } .card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top { border-top-left-radius: 0 } .card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom { border-bottom-left-radius: 0 } } .d-flex { display: flex!important; } .d-inline-flex { display: inline-flex!important } .d-none { display: none!important } .border { border: 1px solid #0003!important; border: var(--bs-border-width) var(--bs-border-style) #00000033 !important; } .border-0 { border: 0!important } .border-top { border-top: var(--bs-border-width) var(--bs-border-style) #00000033 !important; } .border-top-0 { border-top: 0!important } .border-end { border-right: 1px solid #0003!important; border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important } .border-end-0 { border-right: 0!important } .border-bottom { border-bottom: 1px solid #0003!important; border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important } .border-bottom-0 { border-bottom: 0!important } .border-start { border-left: 1px solid #0003!important; border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important } .border-start-0 { border-left: 0!important } .border-default { --bs-border-opacity: 1; border-color: rgba(var(--bs-default-rgb),var(--bs-border-opacity))!important } .border-theme { --bs-border-opacity: 1; border-color: rgba(var(--bs-theme-rgb),var(--bs-border-opacity))!important } .border-theme-color { --bs-border-opacity: 1; border-color: rgba(var(--bs-theme-color-rgb),var(--bs-border-opacity))!important } .border-primary { --bs-border-opacity: 1; border-color: rgba(var(--bs-primary-rgb),var(--bs-border-opacity))!important } .border-secondary { --bs-border-opacity: 1; border-color: rgba(var(--bs-secondary-rgb),var(--bs-border-opacity))!important } .border-warning { --bs-border-opacity: 1; border-color: rgba(var(--bs-warning-rgb),var(--bs-border-opacity))!important } .border-danger { --bs-border-opacity: 1; border-color: rgba(var(--bs-danger-rgb),var(--bs-border-opacity))!important } .border-success { --bs-border-opacity: 1; border-color: rgba(var(--bs-success-rgb),var(--bs-border-opacity))!important } .border-inverse { --bs-border-opacity: 1; border-color: rgba(var(--bs-inverse-rgb),var(--bs-border-opacity))!important } .border-info { --bs-border-opacity: 1; border-color: rgba(var(--bs-info-rgb),var(--bs-border-opacity))!important } .border-dark { --bs-border-opacity: 1; border-color: rgba(var(--bs-dark-rgb),var(--bs-border-opacity))!important } .border-black { --bs-border-opacity: 1; border-color: rgba(var(--bs-black-rgb),var(--bs-border-opacity))!important } .border-white { --bs-border-opacity: 1; border-color: rgba(var(--bs-white-rgb),var(--bs-border-opacity))!important } .border-purple { --bs-border-opacity: 1; border-color: rgba(var(--bs-purple-rgb),var(--bs-border-opacity))!important } .border-indigo { --bs-border-opacity: 1; border-color: rgba(var(--bs-indigo-rgb),var(--bs-border-opacity))!important } .border-red { --bs-border-opacity: 1; border-color: rgba(var(--bs-red-rgb),var(--bs-border-opacity))!important } .border-pink { --bs-border-opacity: 1; border-color: rgba(var(--bs-pink-rgb),var(--bs-border-opacity))!important } .border-green { --bs-border-opacity: 1; border-color: rgba(var(--bs-green-rgb),var(--bs-border-opacity))!important } .border-yellow { --bs-border-opacity: 1; border-color: rgba(var(--bs-yellow-rgb),var(--bs-border-opacity))!important } .border-teal { --bs-border-opacity: 1; border-color: rgba(var(--bs-teal-rgb),var(--bs-border-opacity))!important } .border-muted { --bs-border-opacity: 1; border-color: rgba(var(--bs-muted-rgb),var(--bs-border-opacity))!important } .border-light { --bs-border-opacity: 1; border-color: rgba(var(--bs-light-rgb),var(--bs-border-opacity))!important } .border-lime { --bs-border-opacity: 1; border-color: rgba(var(--bs-lime-rgb),var(--bs-border-opacity))!important } .border-gray-100 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-100-rgb),var(--bs-border-opacity))!important } .border-gray-200 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-200-rgb),var(--bs-border-opacity))!important } .border-gray-300 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-300-rgb),var(--bs-border-opacity))!important } .border-gray-400 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-400-rgb),var(--bs-border-opacity))!important } .border-gray-500 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-500-rgb),var(--bs-border-opacity))!important } .border-gray-600 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-600-rgb),var(--bs-border-opacity))!important } .border-gray-700 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-700-rgb),var(--bs-border-opacity))!important } .border-gray-800 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-800-rgb),var(--bs-border-opacity))!important } .border-gray-900 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-900-rgb),var(--bs-border-opacity))!important } .border-primary-subtle { border-color: #9ac6ff!important; border-color: var(--bs-primary-border-subtle)!important } .border-secondary-subtle { border-color: #a8b6bc!important; border-color: var(--bs-secondary-border-subtle)!important } .border-success-subtle { border-color: #a1d0a7!important; border-color: var(--bs-success-border-subtle)!important } .border-info-subtle { border-color: #99d7f4!important; border-color: var(--bs-info-border-subtle)!important } .border-warning-subtle { border-color: #fdf69e!important; border-color: var(--bs-warning-border-subtle)!important } .border-danger-subtle { border-color: #f39999!important; border-color: var(--bs-danger-border-subtle)!important } .border-light-subtle { border-color: #a8b6bc!important; border-color: var(--bs-light-border-subtle)!important } .border-dark-subtle { border-color: #617a86!important; border-color: var(--bs-dark-border-subtle)!important } .border-1 { border-width: 1px!important } .border-2 { border-width: 2px!important } .border-3 { border-width: 3px!important } .border-4 { border-width: 4px!important } .border-5 { border-width: 5px!important } .border-opacity-10 { --bs-border-opacity: 0.1 } .border-opacity-25 { --bs-border-opacity: 0.25 } .border-opacity-50 { --bs-border-opacity: 0.5 } .border-opacity-75 { --bs-border-opacity: 0.75 } .border-opacity-100 { --bs-border-opacity: 1 } .w-25 { width: 25%!important } .w-50 { width: 50%!important } .w-75 { width: 75%!important } .w-100 { width: 100%!important } .w-auto { width: auto!important } .mw-100 { max-width: 100%!important } .vw-100 { width: 100vw!important } .min-vw-100 { min-width: 100vw!important } .h-25 { height: 25%!important } .h-50 { height: 50%!important } .h-75 { height: 75%!important } .h-100 { height: 100%!important } .h-auto { height: auto!important } .mh-100 { max-height: 100%!important } .vh-100 { height: 100vh!important } .min-vh-100 { min-height: 100vh!important } .flex-fill { flex: 1 1 auto!important } .flex-row { flex-direction: row!important } .flex-column { flex-direction: column!important } .flex-row-reverse { flex-direction: row-reverse!important } .flex-column-reverse { flex-direction: column-reverse!important } .flex-grow-0 { flex-grow: 0!important } .flex-grow-1 { flex-grow: 1!important } .flex-shrink-0 { flex-shrink: 0!important } .flex-shrink-1 { flex-shrink: 1!important } .flex-wrap { flex-wrap: wrap!important } .flex-nowrap { flex-wrap: nowrap!important } .flex-wrap-reverse { flex-wrap: wrap-reverse!important } .justify-content-start { justify-content: flex-start!important } .justify-content-end { justify-content: flex-end!important } .justify-content-center { justify-content: center!important } .justify-content-between { justify-content: space-between!important } .justify-content-around { justify-content: space-around!important } .justify-content-evenly { justify-content: space-evenly!important } .align-items-start { align-items: flex-start!important } .align-items-end { align-items: flex-end!important } .align-items-center { align-items: center!important } .align-items-baseline { align-items: baseline!important } .align-items-stretch { align-items: stretch!important } .align-content-start { align-content: flex-start!important } .align-content-end { align-content: flex-end!important } .align-content-center { align-content: center!important } .align-content-between { align-content: space-between!important } .align-content-around { align-content: space-around!important } .align-content-stretch { align-content: stretch!important } .align-self-auto { align-self: auto!important } .align-self-start { align-self: flex-start!important } .align-self-end { align-self: flex-end!important } .align-self-center { align-self: center!important } .align-self-baseline { align-self: baseline!important } .align-self-stretch { align-self: stretch!important } .order-first { order: -1!important } .order-0 { order: 0!important } .order-1 { order: 1!important } .order-2 { order: 2!important } .order-3 { order: 3!important } .order-4 { order: 4!important } .order-5 { order: 5!important } .order-last { order: 6!important } .m-0 { margin: 0!important } .m-1 { margin: .25rem!important } .m-2 { margin: .5rem!important } .m-3 { margin: 1rem!important } .m-4 { margin: 1.5rem!important } .m-5 { margin: 3rem!important } .m-auto { margin: auto!important } .mx-0 { margin-left: 0!important; margin-right: 0!important } .mx-1 { margin-left: .25rem!important; margin-right: .25rem!important } .mx-2 { margin-left: .5rem!important; margin-right: .5rem!important } .mx-3 { margin-left: 1rem!important; margin-right: 1rem!important } .mx-4 { margin-left: 1.5rem!important; margin-right: 1.5rem!important } .mx-5 { margin-left: 3rem!important; margin-right: 3rem!important } .mx-auto { margin-left: auto!important; margin-right: auto!important } .my-0 { margin-bottom: 0!important; margin-top: 0!important } .my-1 { margin-bottom: .25rem!important; margin-top: .25rem!important } .my-2 { margin-bottom: .5rem!important; margin-top: .5rem!important } .my-3 { margin-bottom: 1rem!important; margin-top: 1rem!important } .my-4 { margin-bottom: 1.5rem!important; margin-top: 1.5rem!important } .my-5 { margin-bottom: 3rem!important; margin-top: 3rem!important } .my-auto { margin-bottom: auto!important; margin-top: auto!important } .mt-0 { margin-top: 0!important } .mt-1 { margin-top: .25rem!important } .mt-2 { margin-top: .5rem!important } .mt-3 { margin-top: 1rem!important } .mt-4 { margin-top: 1.5rem!important } .mt-5 { margin-top: 3rem!important } .mt-auto { margin-top: auto!important } .me-0 { margin-right: 0!important } .me-1 { margin-right: .25rem!important } .me-2 { margin-right: .5rem!important } .me-3 { margin-right: 1rem!important } .me-4 { margin-right: 1.5rem!important } .me-5 { margin-right: 3rem!important } .me-auto { margin-right: auto!important } .mb-0 { margin-bottom: 0!important } .mb-1 { margin-bottom: .25rem!important } .mb-2 { margin-bottom: .5rem!important } .mb-3 { margin-bottom: 1rem!important } .mb-4 { margin-bottom: 1.5rem!important } .mb-5 { margin-bottom: 3rem!important } .mb-auto { margin-bottom: auto!important } .ms-0 { margin-left: 0!important } .ms-1 { margin-left: .25rem!important } .ms-2 { margin-left: .5rem!important } .ms-3 { margin-left: 1rem!important } .ms-4 { margin-left: 1.5rem!important } .ms-5 { margin-left: 3rem!important } .ms-auto { margin-left: auto!important } .m-n1 { margin: -.25rem!important } .m-n2 { margin: -.5rem!important } .m-n3 { margin: -1rem!important } .m-n4 { margin: -1.5rem!important } .m-n5 { margin: -3rem!important } .mx-n1 { margin-left: -.25rem!important; margin-right: -.25rem!important } .mx-n2 { margin-left: -.5rem!important; margin-right: -.5rem!important } .mx-n3 { margin-left: -1rem!important; margin-right: -1rem!important } .mx-n4 { margin-left: -1.5rem!important; margin-right: -1.5rem!important } .mx-n5 { margin-left: -3rem!important; margin-right: -3rem!important } .my-n1 { margin-bottom: -.25rem!important; margin-top: -.25rem!important } .my-n2 { margin-bottom: -.5rem!important; margin-top: -.5rem!important } .my-n3 { margin-bottom: -1rem!important; margin-top: -1rem!important } .my-n4 { margin-bottom: -1.5rem!important; margin-top: -1.5rem!important } .my-n5 { margin-bottom: -3rem!important; margin-top: -3rem!important } .mt-n1 { margin-top: -.25rem!important } .mt-n2 { margin-top: -.5rem!important } .mt-n3 { margin-top: -1rem!important } .mt-n4 { margin-top: -1.5rem!important } .mt-n5 { margin-top: -3rem!important } .me-n1 { margin-right: -.25rem!important } .me-n2 { margin-right: -.5rem!important } .me-n3 { margin-right: -1rem!important } .me-n4 { margin-right: -1.5rem!important } .me-n5 { margin-right: -3rem!important } .mb-n1 { margin-bottom: -.25rem!important } .mb-n2 { margin-bottom: -.5rem!important } .mb-n3 { margin-bottom: -1rem!important } .mb-n4 { margin-bottom: -1.5rem!important } .mb-n5 { margin-bottom: -3rem!important } .ms-n1 { margin-left: -.25rem!important } .ms-n2 { margin-left: -.5rem!important } .ms-n3 { margin-left: -1rem!important } .ms-n4 { margin-left: -1.5rem!important } .ms-n5 { margin-left: -3rem!important } .p-0 { padding: 0!important } .p-1 { padding: .25rem!important } .p-2 { padding: .5rem!important } .p-3 { padding: 1rem!important } .p-4 { padding: 1.5rem!important } .p-5 { padding: 3rem!important } .px-0 { padding-left: 0!important; padding-right: 0!important } .px-1 { padding-left: .25rem!important; padding-right: .25rem!important } .px-2 { padding-left: .5rem!important; padding-right: .5rem!important } .px-3 { padding-left: 1rem!important; padding-right: 1rem!important } .px-4 { padding-left: 1.5rem!important; padding-right: 1.5rem!important } .px-5 { padding-left: 3rem!important; padding-right: 3rem!important } .py-0 { padding-bottom: 0!important; padding-top: 0!important } .py-1 { padding-bottom: .25rem!important; padding-top: .25rem!important } .py-2 { padding-bottom: .5rem!important; padding-top: .5rem!important } .py-3 { padding-bottom: 1rem!important; padding-top: 1rem!important } .py-4 { padding-bottom: 1.5rem!important; padding-top: 1.5rem!important } .py-5 { padding-bottom: 3rem!important; padding-top: 3rem!important } .pt-0 { padding-top: 0!important } .pt-1 { padding-top: .25rem!important } .pt-2 { padding-top: .5rem!important } .pt-3 { padding-top: 1rem!important } .pt-4 { padding-top: 1.5rem!important } .pt-5 { padding-top: 3rem!important } .pe-0 { padding-right: 0!important } .pe-1 { padding-right: .25rem!important } .pe-2 { padding-right: .5rem!important } .pe-3 { padding-right: 1rem!important } .pe-4 { padding-right: 1.5rem!important } .pe-5 { padding-right: 3rem!important } .pb-0 { padding-bottom: 0!important } .pb-1 { padding-bottom: .25rem!important } .pb-2 { padding-bottom: .5rem!important } .pb-3 { padding-bottom: 1rem!important } .pb-4 { padding-bottom: 1.5rem!important } .pb-5 { padding-bottom: 3rem!important } .ps-0 { padding-left: 0!important } .ps-1 { padding-left: .25rem!important } .ps-2 { padding-left: .5rem!important } .ps-3 { padding-left: 1rem!important } .ps-4 { padding-left: 1.5rem!important } .ps-5 { padding-left: 3rem!important } .gap-0 { gap: 0!important } .gap-1 { gap: .25rem!important } .gap-2 { gap: .5rem!important } .gap-3 { gap: 1rem!important } .gap-4 { gap: 1.5rem!important } .gap-5 { gap: 3rem!important } .row-gap-0 { row-gap: 0!important } .row-gap-1 { row-gap: .25rem!important } .row-gap-2 { row-gap: .5rem!important } .row-gap-3 { row-gap: 1rem!important } .row-gap-4 { row-gap: 1.5rem!important } .row-gap-5 { row-gap: 3rem!important } .flex-1 { flex: 1 1!important } .card-expand .app-content { height: calc(100vh - 3.25rem); overflow: hidden; position: relative; z-index: 1120 } .card { --bs-border-color-rgb: var(--bs-body-color-rgb); background: #ffffff0a; border: none; position: relative; max-width: 940px; width: 100%; margin: 24px auto; } .card.border-theme { --bs-border-color-rgb: var(--bs-theme-rgb) } .card.card-expand { background: #1d2835fa; border-radius: 0; bottom: 0; height: auto!important; left: 0; margin: 0!important; padding: .3125rem; position: fixed; right: 0; top: 0; z-index: 1120 } .card.card-expand .card-body,.card.card-expand .card-header { border-radius: 0 } .card.card-expand .card-body { flex: 1 0; height: auto!important; overflow: scroll } .card.card-expand:not(.border-0):before { bottom: 5px; left: 20px; right: 20px; top: 5px } .card.card-expand:not(.border-0):after { bottom: 20px; left: 5px; right: 5px; top: 20px } .card.card-expand .card-arrow { margin: 5px } .card .card-header .card-header-tabs .nav-item .nav-link.active { border-bottom-color: #0000 } .card .card-body .nav-tabs .nav-item .nav-link.active { background: var(--bs-card-bg); border-bottom-color: var(--bs-card-bg) } .card:after,.card:before { content: ""; position: absolute } .card:not(.border-0):before { } .card:not(.border-0):after { } .card>:not(.card-arrow):not(.card-img-overlay):not(.card-img):not(.hljs-container) { position: relative; z-index: 10 } .card .card-arrow {display: none;} .card .card-arrow-bottom-left,.card .card-arrow-bottom-right,.card .card-arrow-top-left,.card .card-arrow-top-right { height: 10px; position: absolute; width: 10px } .card .card-arrow-bottom-left:before,.card .card-arrow-bottom-right:before,.card .card-arrow-top-left:before,.card .card-arrow-top-right:before { background: rgb(0 0 0 / 75%); content: ""; height: 8px; position: absolute; width: 2px } .card .card-arrow-bottom-left:after,.card .card-arrow-bottom-right:after,.card .card-arrow-top-left:after,.card .card-arrow-top-right:after { background: rgb(0 0 0 / 75%); content: ""; height: 2px; position: absolute; width: 10px } .card .card-arrow-top-left,.card .card-arrow-top-right { top: 0 } .card .card-arrow-top-left:before,.card .card-arrow-top-right:before { top: 2px } .card .card-arrow-top-left:after,.card .card-arrow-top-right:after { top: 0 } .card .card-arrow-bottom-left,.card .card-arrow-bottom-right { bottom: 0 } .card .card-arrow-bottom-left:before,.card .card-arrow-bottom-right:before { bottom: 2px } .card .card-arrow-bottom-left:after,.card .card-arrow-bottom-right:after { bottom: 0 } .card .card-arrow-bottom-left,.card .card-arrow-bottom-left:after,.card .card-arrow-bottom-left:before,.card .card-arrow-top-left,.card .card-arrow-top-left:after,.card .card-arrow-top-left:before { left: 0 } .card .card-arrow-bottom-right,.card .card-arrow-bottom-right:after,.card .card-arrow-bottom-right:before,.card .card-arrow-top-right,.card .card-arrow-top-right:after,.card .card-arrow-top-right:before { right: 0 } .px-3.py-2.mt-3 { border: 1px solid #00000033 !important;!i;!; } .progress.flex-1 { display: none; } span.d-block { display: block; }
            .d-flex.flex-wrap.gap-3.image-row {float: left;overflow: hidden;} .d-flex.flex-wrap.gap-3.image-row a { height: 210px; display: block; overflow: hidden; } .d-flex.flex-wrap.gap-3.image-row a im {} .d-flex.flex-wrap.gap-3.image-row a img { width: 100%; height: 100% !important;!i;!; object-fit: contain; } .mt-3.position-relative { overflow: hidden; }
            </style>
          </head>
          <body><div class="row g-4">${printContent.innerHTML}</div></body>
        </html>
      `
        );
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
      }
    }
  }

  const handleEventsRow = async () => {
    const allFilled = fileItemEvents.column.columns.every(
      (item) =>
        formData[item] && formData[item] !== "" && formData[item] !== null
    );

    if (!allFilled) {
      toastMessage(context?.t?.satirlar_bos_birakilamaz, "error");
      return;
    }

    const formattedData = formatDatesInJson(formData);

    if (formattedData) {
      const resultArray = Object.entries(formattedData).map(
        ([key, value]) => value
      );

      const csvContent = [
        fileItemEvents.column.columns.join(";"),
        resultArray.join(";"),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const file = new File([blob], `${fileItemEvents.type.type}.csv`, {
        type: "text/csv",
      });

      //--

      const maxFileSize = 200 * 1024 * 1024; // 5MB in bytes

      if (file.size > maxFileSize) {
        toastMessage(context?.t?.max_200_mb, "error");
        return;
      }
      if (!file) {
        toastMessage(context?.t?.file_important, "error");
        return;
      }

      const payloadformData = new FormData();
      payloadformData.append("file", file);
      payloadformData.append(
        "data_type",
        context?.me?.role?.id === 1
          ? fileTypesCustomer.value
            ? "custom"
            : "global"
          : "custom"
      );
      payloadformData.append(
        "user_id",
        fileTypesCustomer?.value ? fileTypesCustomer?.user_id : context?.me?.id
      );
      payloadformData.append("type", fileItemEvents.type.type);
      payloadformData.append("separator", ";");
      fileItemEvents.column.types.forEach((item, index) => {
        payloadformData.append(
          "columns[" + index + "][key]",
          fileItemEvents.column.columns[index]
        );
        payloadformData.append("columns[" + index + "][value]", item.value);
      });

      // for (var pair of payloadformData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }

      //--

      if (fileItemEvents.row) {
        const deletePayload = {
          connection_type: connectionType,
          sql: {
            condition: fileItemEvents.column.columns.map((item, index) => ({
              key: item,
              value: Object.values(fileItemEvents.row)[index],
              operator: "=",
              type: "and",
            })),
          },
          type: fileItemEvents.type.type,
        };

        try {
          // İlk olarak DELETE işlemi yapılır
          const deleteResponse = await apiClient.customPost(
            `/delete/query`,
            deletePayload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          if (deleteResponse.success) {
            // DELETE işlemi başarılıysa
            toastMessage(context?.t?.veriler_silindi, "success");

            // Daha sonra ikinci işlemi yap
            try {
              const uploadResponse = await apiClient.post(
                "/csv/upload",
                payloadformData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                }
              );

              if (uploadResponse.status) {
                toastMessage(context?.t?.satir_guncellendi, "success");
                setTimeout(() => {
                  document
                    .getElementById("yuklenenDosyalarIslemlerCloseButton")
                    .click();
                  handleFileTypesCustomer(
                    context?.me?.role?.id === 1
                      ? {
                          value: fileTypesCustomer.value,
                          label: fileTypesCustomer.label,
                        }
                      : {
                          value:
                            localStorage.getItem("user") &&
                            JSON.parse(localStorage.getItem("user")).customer
                              .id,
                          label:
                            localStorage.getItem("user") &&
                            JSON.parse(localStorage.getItem("user")).customer
                              .customer.name,
                        },
                    connectionType
                  );
                }, 300);
              } else {
                toastMessage(context?.t?.satir_guncellenemedi, "error");
              }
            } catch (uploadError) {
              console.error("Satır Yükleme Hatası", uploadError);
            }
          } else {
            toastMessage(context?.t?.veriler_silindi, "error");
          }

          setDeleteLoader(false);
        } catch (deleteError) {
          console.error("Veri Silme Hatası", deleteError);
          setDeleteLoader(false);
        }
      } else {
        try {
          const response = await apiClient.post(
            "/csv/upload",
            payloadformData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          if (response.status) {
            toastMessage(context?.t?.satir_yuklendi, "success");

            setTimeout(() => {
              document
                .getElementById("yuklenenDosyalarIslemlerCloseButton")
                .click();
              setFileItemEvents(null);
              setFormData({});
            }, 300);
          } else {
            toastMessage(context?.t?.satir_yuklenemedi, "error");
          }
        } catch (error) {
          console.error("Satır Ekle Hatası", error);
        }
      }
    }
  };

  const [visibleId, setVisibleId] = useState(null);

  return (
    <div className="row mb-5 pb-5">
      <div className="col-12">
        <div className="row">
          {context?.me?.role?.id === 1 && (
            <div className="col flex-none" style={{ maxWidth: 300 }}>
              <span className="mb-1 d-block">
                {context?.t?.choose_customer}
              </span>
              {context.allCustomerSelect ? (
                <Select
                  options={[
                    {
                      value: null,
                      label: "Global",
                      user_id: null,
                    },
                    ...context.allCustomerSelect,
                  ]}
                  placeholder=""
                  classNamePrefix="react-select"
                  noOptionsMessage={() => context?.t?.no_option}
                  value={fileTypesCustomer}
                  onChange={(e) => handleFileTypesCustomer(e, connectionType)}
                />
              ) : (
                <div className="spinner-border spinner-border-sm text-theme"></div>
              )}
            </div>
          )}

          <div className="col flex-none" style={{ maxWidth: 300 }}>
            <span className="mb-1 d-block">{context?.t?.dosya_ara}</span>
            <input
              type="text"
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="col-12">
        <hr />
      </div>

      {fileTypes && fileTypesCustomer && fileTypesCustomer.value && (
        <div className="col-12">
          <div className="row g-3 mb-3">
            {[
              {
                type: "bireysel-data-customer-" + fileTypesCustomer.value,
              },
              {
                type: "hane-data-customer-" + fileTypesCustomer.value,
              },
              {
                type: "akraba-data-customer-" + fileTypesCustomer.value,
              },
            ].map((item, index) => (
              <FileItem
                key={index}
                id={index + 1}
                setSelectedFile={setSelectedFile}
                item={item}
                setVisibleId={setVisibleId}
                setTypeData={setTypeData}
                setFileItemEvents={setFileItemEvents}
                connectionType={connectionType}
              />
            ))}
          </div>

          <hr />
        </div>
      )}

      {context?.me?.role?.id !== 7 && (
        <div className="mt-3 col-12 mb-3 d-flex flex-wrap gap-2 align-items-center">
          <h4 className="mb-0">{context?.t?.sizin_yukledikleriniz}</h4>

          <button
            type="button"
            className={`btn btn-sm ${
              connectionType === "local" ? "btn-theme" : "btn-outline-theme"
            }`}
            onClick={() => setConnectionType("local")}
          >
            {context?.t?.proje_veritabanim}
          </button>

          <button
            type="button"
            className={`btn btn-sm ${
              connectionType === "remote" ? "btn-theme" : "btn-outline-theme"
            }`}
            onClick={() => setConnectionType("remote")}
          >
            {context?.t?.benim_veritabanim}
          </button>
        </div>
      )}

      <div className="col-12">
        <div className="row g-3">
          {fileTypes ? (
            <>
              {fileTypes
                .filter((item) => {
                  if (searchTerm.trim() === "") {
                    return true;
                  }
                  return item.type
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());
                })
                .filter(
                  (item) =>
                    item.type.split("-customer")[0] !== "bireysel-data" &&
                    item.type.split("-customer")[0] !== "hane-data" &&
                    item.type.split("-customer")[0] !== "akraba-data"
                )
                .sort((a, b) => a.type.localeCompare(b.type))
                .map((item, index) =>
                  visibleId ? (
                    visibleId === index + 1 && (
                      <FileItem
                        key={index}
                        setSelectedFile={setSelectedFile}
                        id={index + 1}
                        setVisibleId={setVisibleId}
                        item={item}
                        setTypeData={setTypeData}
                        setFileItemEvents={setFileItemEvents}
                        connectionType={connectionType}
                      />
                    )
                  ) : context?.me?.role?.id === 7 ? (
                    item.type.startsWith("manuel-") && (
                      <FileItem
                        key={index}
                        setSelectedFile={setSelectedFile}
                        id={index + 1}
                        setVisibleId={setVisibleId}
                        item={item}
                        setTypeData={setTypeData}
                        setFileItemEvents={setFileItemEvents}
                        connectionType={connectionType}
                      />
                    )
                  ) : (
                    <FileItem
                      key={index}
                      setSelectedFile={setSelectedFile}
                      id={index + 1}
                      setVisibleId={setVisibleId}
                      item={item}
                      setTypeData={setTypeData}
                      setFileItemEvents={setFileItemEvents}
                      connectionType={connectionType}
                    />
                  )
                )}
            </>
          ) : (
            <div className="col-12">
              <div className="spinner-border text-theme"></div>
            </div>
          )}
        </div>
      </div>

      <div
        className="modal modal-cover fade"
        id="yuklenenDosyalarIslemler"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog py-4" style={{ maxWidth: 1000 }}>
          <div
            className="modal-content rounded"
            style={{ background: "var(--bs-dark4)" }}
          >
            <div className="modal-header">
              <div>
                <h3 className="modal-title">
                  {fileItemEvents && fileItemEvents.row
                    ? context?.t?.satir_guncelle
                    : context?.t?.satir_ekle}
                </h3>
                <span className="d-block">
                  {fileItemEvents &&
                    fileItemEvents.type.type.split("-customer")[0]}
                </span>
              </div>

              <button
                type="button"
                className="btn-close"
                id="yuklenenDosyalarIslemlerCloseButton"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {fileItemEvents && (
              <>
                <div className="modal-body border-top pb-4">
                  <div className="row g-4" ref={printRef}>
                    {fileItemEvents.row
                      ? Object.keys(fileItemEvents.row).map((key, index) => (
                          <div className="col col-md-4" key={key}>
                            <label>
                              {fileItemEvents.column.columns[index]}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={
                                formData[
                                  fileItemEvents.column.columns[index]
                                ] || ""
                              }
                              required
                              onChange={(e) =>
                                handleInputChange(
                                  fileItemEvents.column.columns[index],
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        ))
                      : fileItemEvents.column.types.map((item, index) => (
                          <div className="col col-md-4" key={item.key}>
                            <label>
                              {fileItemEvents.column.columns[index]}
                            </label>
                            {item.value === "date" ? (
                              <DatePicker
                                locale="tr"
                                className="form-control"
                                required
                                selected={
                                  formData[fileItemEvents.column.columns[index]]
                                }
                                onChange={(date) =>
                                  handleInputChange(
                                    fileItemEvents.column.columns[index],
                                    date
                                  )
                                }
                              />
                            ) : (
                              <input
                                type={
                                  item.value === "integer" ||
                                  item.value === "id" ||
                                  item.value === "phone"
                                    ? "number"
                                    : item.value === "email"
                                    ? "email"
                                    : "text"
                                }
                                required
                                className="form-control"
                                value={
                                  formData[
                                    fileItemEvents.column.columns[index]
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    fileItemEvents.column.columns[index],
                                    e.target.value
                                  )
                                }
                              />
                            )}
                          </div>
                        ))}
                  </div>
                </div>

                <div className="modal-footer border-top">
                  {fileItemEvents && fileItemEvents.row && (
                    <button
                      type="button"
                      className="btn btn-outline-theme"
                      onClick={() => handlePrint()}
                    >
                      {context?.t?.rapor}
                    </button>
                  )}

                  <button
                    type="button"
                    className="btn btn-outline-theme"
                    onClick={() => handleEventsRow()}
                  >
                    {fileItemEvents && fileItemEvents.row
                      ? context?.t?.update
                      : context?.t?.ekle}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal modal-cover fade"
        id="yuklenenDosyalarModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog py-4" style={{ maxWidth: 1000 }}>
          <div
            className="modal-content rounded"
            style={{ background: "var(--bs-dark4)" }}
          >
            <div className="modal-header">
              <div>
                <h3 className="modal-title">{context?.t?.kosul_olustur}</h3>
                <span className="d-block">
                  {typeData && typeData.type.type.split("-customer")[0]}
                </span>
              </div>

              <button
                type="button"
                className="btn-close"
                id="yuklenenDosyalarModalCloseButton"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {typeData && (
              <div className="modal-body">
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-outline-theme w-100 mb-3"
                    onClick={handleAddCondition}
                  >
                    {context?.t?.add_condition}
                  </button>

                  {conditions.length === 0 && (
                    <p>{context?.t?.you_can_add_condition}</p>
                  )}

                  {conditions.map((condition, index) => (
                    <div
                      className="row align-items-center g-2 mb-2"
                      key={index}
                    >
                      <div
                        className="col w-auto"
                        style={{ flex: "none", minWidth: 80 }}
                      >
                        {index + 1}. {context?.t?.condition}:
                      </div>
                      <div className="col">
                        <Select
                          options={typeData.column.map((item) => ({
                            value: item,
                            label: item,
                          }))}
                          value={condition.column}
                          onChange={(option) =>
                            handleChange(index, "column", option)
                          }
                          placeholder={context?.t?.choose_column}
                          classNamePrefix="react-select"
                          noOptionsMessage={() => context?.t?.no_option}
                        />
                      </div>
                      <div className="col">
                        <Select
                          options={selectedConditionOptions}
                          value={condition.operator}
                          onChange={(option) =>
                            handleChange(index, "operator", option)
                          }
                          placeholder={context?.t?.selectOperator}
                          classNamePrefix="react-select"
                          noOptionsMessage={() => context?.t?.no_option}
                        />
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={context?.t?.value}
                          value={condition.value}
                          onChange={(e) =>
                            handleChange(index, "value", e.target.value)
                          }
                          disabled={
                            condition.operator.value === "isnull" ||
                            condition.operator.value === "isnotnull"
                          }
                        />
                      </div>
                      <div className="col">
                        <Select
                          options={selectedOperatorOptions}
                          value={condition.condition}
                          onChange={(option) =>
                            handleChange(index, "condition", option)
                          }
                          placeholder={context?.t?.choose_condition}
                          classNamePrefix="react-select"
                          noOptionsMessage={() => context?.t?.no_option}
                        />
                      </div>
                      <div className="col w-auto" style={{ flex: "none" }}>
                        <button
                          className="btn border-0 btn-danger h-100"
                          onClick={() => handleRemoveCondition(index)}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="row mt-4">
                  <div className="col">
                    <button
                      type="button"
                      className="btn btn-dark w-100"
                      data-bs-dismiss="modal"
                    >
                      {context?.t?.cancel}
                    </button>
                  </div>

                  <div className="col">
                    <button
                      type="button"
                      className="btn btn-outline-theme w-100 mb-3"
                      onClick={handleSubmit}
                    >
                      {context?.t?.preview}
                    </button>
                  </div>
                </div>

                <hr />

                {previewData ? (
                  previewData.data.length !== 0 ? (
                    <>
                      <div className="table-responsive" style={{ height: 500 }}>
                        <table className="table">
                          <thead>
                            <tr>
                              {typeData.column.map((header, index) => (
                                <th
                                  style={{ whiteSpace: "nowrap" }}
                                  key={index}
                                >
                                  {header}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {previewData.data.map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                {Object.values(row).map((cell, cellIndex) => (
                                  <td key={cellIndex}>{cell}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="dataTables_paginate paging_simple_numbers d-flex justify-content-center text-center mt-4">
                        <ul className="pagination">
                          <li className={`paginate_button page-item`}>
                            <button
                              type="button"
                              onClick={() => handlePageChange(currentPage - 1)}
                              className={`page-link pointer ${
                                !previewData.prev_page_url ? "disabled" : ""
                              }`}
                            >
                              {context?.t?.prev}
                            </button>
                          </li>

                          {previewData.links.map(
                            (number, index) =>
                              index > 0 &&
                              index < previewData.links.length - 1 && (
                                <li
                                  key={index}
                                  className={`paginate_button page-item ${
                                    currentPage === parseInt(number.label)
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <div
                                    onClick={() =>
                                      handlePageChange(parseInt(number.label))
                                    }
                                    className="page-link pointer"
                                  >
                                    {number.label}
                                  </div>
                                </li>
                              )
                          )}

                          <li className={`paginate_button page-item`}>
                            <button
                              type="button"
                              onClick={() => handlePageChange(currentPage + 1)}
                              className={`page-link pointer ${
                                !previewData.next_page_url ? "disabled" : ""
                              }`}
                            >
                              {context?.t?.next}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </>
                  ) : (
                    <span>{context?.t?.no_data_available}</span>
                  )
                ) : (
                  <div className="spinner-border  text-theme"></div>
                )}

                {previewData && previewData.data.length !== 0 && (
                  <>
                    <hr />

                    <div className="">
                      <div
                        className="form-check form-checkbox mb-3 mx-auto"
                        style={{ maxWidth: 400 }}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="yuklenen_dosyalar_show_remove_button"
                          onChange={(e) =>
                            setShowRemoveButton(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="yuklenen_dosyalar_show_remove_button"
                          dangerouslySetInnerHTML={{
                            __html: context?.t?.error_delete_condition,
                          }}
                        />
                      </div>

                      <div className="d-flex gap-2 justify-content-center">
                        {showRemoveButton && (
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() =>
                              handleFileDelete(typeData.type.type, conditions)
                            }
                            disabled={deleteLoader}
                          >
                            {context?.t?.secilenleri_kaldir}
                            {deleteLoader && (
                              <div className="spinner-border spinner-border-sm text-danger"></div>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal modal-cover fade"
        id="yuklenenDosyalarDeleteModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog py-4">
          <div
            className="modal-content rounded"
            style={{ background: "var(--bs-dark4)" }}
          >
            <div className="modal-header">
              <h3 className="modal-title">
                <span className="h5">
                  {selectedFile?.type.split("-customer")[0]}
                </span>
              </h3>

              <button
                type="button"
                className="btn-close"
                id="yuklenenDosyalarDeleteModalCloseButton"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body text-center mb-3">
              <h4>{context?.t?.error_delete_data_graphics}</h4>

              <button
                type="button"
                className="btn btn-danger mt-3"
                onClick={() => handleFileDelete(selectedFile?.type, null)}
                disabled={deleteLoader}
              >
                {context?.t?.tumunu_kaldir}
                {deleteLoader && (
                  <div className="spinner-border spinner-border-sm text-white ms-1"></div>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-cover fade"
        id="fileListImportModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog">
          <div
            className="modal-content rounded"
            style={{ background: "var(--bs-dark4)" }}
          >
            <div className="modal-header">
              <h3 className="modal-title">{context?.t?.uzerine_veri_yukle}</h3>
              <button
                type="button"
                className="btn-close"
                id="fileListImportModalCloseButton"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {selectedFile && (
              <div className="modal-body">
                <span className="d-block mb-3">
                  {context?.t?.secilen}:{" "}
                  {selectedFile?.type.split("-customer")[0]}
                </span>

                <ImportFile
                  closeId="fileListImportModalCloseButton"
                  dataname={
                    selectedFile?.type === "bireysel-data" ||
                    selectedFile?.type === "hane-data" ||
                    selectedFile?.type === "akraba-data"
                      ? selectedFile?.type +
                        "-customer-" +
                        fileTypesCustomer.value
                      : selectedFile?.type
                  }
                  pageImport={true}
                  customerProps={fileTypesCustomer}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
